import moment from '@/moment-gp'
import { generateReferralCode } from './util'

export default {
  create( _, data ) {
    return {
      createdAt:      moment.currentTimeServer('REALTIMEDB'),

      /* Subscription */
      // TODO: Subscription list: see project payment gatewy
      subscription:           "Free",
      // duration:            "2591970",
      // subscriptionStatus:  "active",
      // subscriptions:       {[teamUser1_subscriptionId1]: {} }
      // payment:             "OneTime",

      /*
      User account status:
        new user       => "init",
        active user    => "creating",
        active user    => "active", ( = ready)
        deactived user => "inactive",
        deleted user   => "deleted"
      */
      status:         data.status || "creating",

      /* Personal referral code, user can use to invite others */
      referralCode:   generateReferralCode(),

      /* Referal bonus */
      referralBonus:  10, // = used as upvotes

      /* Goalpilots internal currency */
      goalcoins:      0,

      /* Who invited this user */
      invitedBy:      data.invitedBy || null,

      // TODO: referral userlist + bonus
    }
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    status: { validate_bolt_type: 'String' },
    subscription: { validate_bolt_type: 'String' },
    payment: { validate_bolt_type: 'String' },
    referralCode: { validate_bolt_type: 'String' },
    referralBonus: { validate_bolt_type: 'Number' },
    duration: { validate_bolt_type: 'Number' },
    goalcoins: { validate_bolt_type: 'Number' },
    invitedBy: { validate_bolt_type: 'UserID' },
  }
};
